<template>
  <div class="category-panel my-5">
    <div class="row gy-5">
      <div
        v-for="productCategory in productCategories"
        :key="productCategory.id"
        :class="{ 'col-4': isWindowSmall, 'col-3': !isWindowSmall }"
      >
        <CategoryCard
          :productCategory="productCategory"
          @goToProducts="updateFilters(productCategory.id)"
        />
      </div>
    </div>
    <CategoryModal
      :title="$store.state.products.content.ListProducts.readMoreCategories"
      :categoryChosen="!(categoryText.name == null)"
      @clearCategory="clearCategory()"
    >
      <div v-if="categoryText.description">
        <h3>{{ categoryText.name }}</h3>
        <div v-html="categoryText.description"></div>
      </div>
      <div
        v-else
        v-for="productCategory in productCategories"
        :key="productCategory.id"
        class="inherit-link-styling"
      >
        <a @click="showCategory(productCategory.name_d)">{{
          productCategory.name_d
        }}</a>
      </div>
    </CategoryModal>
  </div>
</template>

<script>
import CategoryCard from "@/components/products/CategoryCard.vue";
import CategoryModal from "@/components/products/CategoryModal.vue";

export default {
  emits: ["filtersUpdated"],
  props: ["productCategories", "isWindowSmall"],
  components: {
    CategoryCard,
    CategoryModal,
  },
  data() {
    return {
      categoryText: { name: null, description: null },
    };
  },
  methods: {
    clearCategory() {
      this.categoryText.name = null;
      this.categoryText.description = null;
    },
    showCategory(name) {
      this.categoryText.name = name;
      this.categoryText.description = this.$store.state.products.content.ListProducts.noCategoryDescription;
      const images = this.$store.state.products.categoryImages;
      if (images.length > 0) {
        images.forEach((image) => {
          if (name) {
            if (name.toLowerCase().includes(image.category)) {
              //Update description if there's a match in Vuex store categoryImages
              this.categoryText.description = image.description;
            }
          }
        });
      }
    },
    updateFilters(id) {
      this.$store.commit("products/setCategoryFilters", {
        categoryFilters: [Number(id)],
      });
      this.$emit("filtersUpdated");
    },
  },
};
</script>

<style>
/* .category-info-modal .modal.fade .modal-dialog {
  transform: translate3d(0, 100vh, 0);
}
.category-info-modal .modal.fade.show .modal-dialog {
  transform: translate3d(0, 0, 0);
  transition: transform 0.25s ease-out;
}
.category-info-modal .modal-dialog {
  max-width: unset !important;
} */
.category-info-modal .filter-link::before {
  content: "\2807 ";
}
.category-info-modal .modal-title::before {
  content: "\2807 ";
}
</style>
